import { render } from "./privacyAndPolicy.vue?vue&type=template&id=8719f31e"
import script from "./privacyAndPolicy.vue?vue&type=script&lang=ts"
export * from "./privacyAndPolicy.vue?vue&type=script&lang=ts"
script.render = render

export default script